import http from "@/http-common";
import './security';

class GroupService {
  create(data) {
    return http.post("/group", data);
  }

  getAll() {
    return http.get("/group");
  }

  getGroupListByLocationId(id){
    return http.get(`/group/location/${id}`)
  }

  getSHM(id, arrayPos){
    return http.get(`/group/shm/${id}/pos/${arrayPos}`)
  }


  /* ALE: Obtenemos el ultimo dato para ver su hora y autoconfigurar la gráfica en función de esto
    1. Obtener el ulitmo timestamp y gestionar los Datepicker
    2. Lanzar la gráfica pidiendo los datos desde esa última hora
    >> Metido parametro limite de resultados
  */
  getFreq(id, serverParams){
    let dataToSend = {
      headers: {
        serverParams: JSON.stringify(serverParams)
      }
    }
    return http.get(`/group/freq/${id}`, dataToSend)
  }

  get(id) {    
    return http.get(`/group/id/${id}`);
  }

  update(data) {
    return http.put(`/group/id/${data._id}`, data);
  }

  delete(id) {    
    return http.delete(`/group/id/${id}`);
  }

  deleteAll() {
    return http.delete(`/group`);
  }

  getSensorCountFromId(id){
    return http.get(`/group/count/${id}`);
  }

  getFreqDeviationsBySensorId(id, serverParams){
    let data = {
      headers:{serverParams: JSON.stringify(serverParams)}
    };  
    return http.get(`/group/freqdev/${id}`, data);
  }

  getShmConfigBySensorId(id) {
    return http.get(`/group/shmconfig/${id}`)
  }

  updateShmConfigBySensorId(id, data) {
    return http.put(`/group/shmconfig/${id}`, data)
  }

  getAlertInfoFromSensorId(id) {
    return http.get(`/group/shmalert/${id}`)
  }

  getAlertSensorsFromLocation(id) {
    return http.get(`/group/alertsensor/location/${id}`)
  }

  updateAlertInfoFromSensorId(id, data) {
    return http.put(`/group/shmalert/${id}`, data)
  }

  getSummaryData(id) {
    return http.get(`/group/summary/${id}`)
  }

  getLastShm(id) {
    return http.get(`/group/shm/last/${id}`)
  }

}

export default new GroupService();
